module.exports = __webpack_public_path__ + "img/live.cca7a54f.png";